var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTv = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1871 0C17.5742 0 17.9032 0.141129 18.1742 0.423387C18.4452 0.705645 18.5806 1.04839 18.5806 1.45161V11.129C18.5806 11.5323 18.4452 11.875 18.1742 12.1573C17.9032 12.4395 17.5742 12.5806 17.1871 12.5806H10.3645V13.5484H15.0097C15.2613 13.5484 15.4742 13.6391 15.6484 13.8206C15.8419 14.0222 15.9387 14.254 15.9387 14.5161C15.9387 14.7782 15.8419 15 15.6484 15.1815C15.4742 15.3831 15.2613 15.4839 15.0097 15.4839H3.86129C3.60968 15.4839 3.3871 15.3831 3.19355 15.1815C3.01935 15 2.93226 14.7782 2.93226 14.5161C2.93226 14.254 3.01935 14.0222 3.19355 13.8206C3.3871 13.6391 3.60968 13.5484 3.86129 13.5484H8.50645V12.5806H1.39355C1.00645 12.5806 0.677419 12.4395 0.406452 12.1573C0.135484 11.875 0 11.5323 0 11.129V1.45161C0 1.04839 0.135484 0.705645 0.406452 0.423387C0.677419 0.141129 1.00645 0 1.39355 0H17.1871ZM16.7226 10.6452V1.93548H1.85806V10.6452H16.7226Z",
    fill: "#C4C4C4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTv, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tv.d7b115d2.svg";
export { ForwardRef as ReactComponent };